import React from "react";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";

export interface SearchableSelectOption {
  value: string | number;
  label: string;
}

interface SearchableMultiSelectProps {
  inputId: string;
  label: string;
  options: SearchableSelectOption[];
  value: Array<string | number>;
  onChange: (value: Array<string | number>) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  selectionLimit?: number;
  display?: "comma" | "chip";
  showClear?: boolean;
}

export default function SearchableMultiSelect({
  inputId,
  label,
  options,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = "Select",
  selectionLimit,
  display = "comma",
  showClear = false,
}: SearchableMultiSelectProps) {
  return (
    <label htmlFor={inputId} className="block text-sm font-medium">
      {label}
      <MultiSelect
        inputId={inputId}
        value={value}
        options={options}
        optionLabel="label"
        optionValue="value"
        filter
        filterBy="label"
        filterPlaceholder={`Search ${label.toLowerCase()}`}
        display={display}
        maxSelectedLabels={display === "chip" ? undefined : 1}
        selectionLimit={selectionLimit}
        showClear={showClear}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        className="mt-1 w-full text-sm"
        pt={
          display === "chip"
            ? {
                label: {
                  style: {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "0.25rem",
                    whiteSpace: "normal",
                  },
                },
                token: { style: { maxWidth: "100%", margin: 0 } },
                tokenLabel: {
                  style: {
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                },
                removeTokenIcon: { style: { flexShrink: 0 } },
              }
            : undefined
        }
        panelClassName="text-sm"
        onChange={(event: MultiSelectChangeEvent) => onChange(event.value ?? [])}
      />
    </label>
  );
}
